import { styled } from 'styled-components'
import { media } from '../../../../utils/styles'

// Currently the ClbHeader does not support responsive design so we need to implement it manually
export const Wrapper = styled.div`
  width: 100%;

  & > .Header {
    padding: 0px var(--spacing-size-xs);
  }

  & > .Header > .Header__notification {
    display: block;
  }

  & > .Header > .avatar-container {
    display: inline-flex;
  }

  & > .Header > .avatar-container .dropdown > .dropdown-items {
    min-width: 160px;
  }

  ${media.smallMobile`
    & > .Header > .avatar-container {
      margin-left: var(--spacing-size-3xs);
    }
  `}
`
